import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useWorkspace } from '../../../context/WorkspaceContext';
import { LoadingIndicator } from '../../../components/Tools/LoadingIndicator';

const AUTHORIZED_EMAILS = ['contact@frenzypost.com'];

const AdminRoute = ({ children }) => {
  const { user, idToken } = useWorkspace();
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuthorization = async () => {
      if (!user || !idToken) {
        setIsAuthorized(false);
        setIsLoading(false);
        return;
      }

      try {
        // Check if the user's email is in the authorized list
        const userEmail = user.email;
        if (userEmail && AUTHORIZED_EMAILS.includes(userEmail.toLowerCase())) {
          setIsAuthorized(true);
        } else {
          setIsAuthorized(false);
        }
      } catch (error) {
        console.error('Error checking admin authorization:', error);
        setIsAuthorized(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthorization();
  }, [user, idToken]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <LoadingIndicator showLogo={true} />
      </div>
    );
  }

  if (!isAuthorized) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default AdminRoute; 